<template>
  <p>
    <span class="text-justify" v-html="agreementText(agreement)"></span>
    <br>
    <a v-if="agreement.less" class="bold cursor-pointer" @click="toggleMore">{{ toggleText }}</a>
  </p>
</template>

<script>
import {encode} from "@/utils/EncodeHtmlEntities";

export default {
  name: "AgreementText",
  props: {
    agreement: Object
  },
  data() {
    return {
      showMore: false
    }
  },
  methods: {
    agreementText(agreement) {
      if (this.showMore) {
        return encode(agreement.content || agreement.name);
      }

      return encode(agreement.less || agreement.content || agreement.name);
    },
    toggleMore() {
      this.showMore = !this.showMore;
    }
  },
  computed: {
    toggleText() {
      return this.showMore
          ? 'Pokaż mniej'
          : 'Pokaż więcej';
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
